<div class="field-wrapper d-flex align-items-end" [ngStyle]="fieldStyle" (click)="showAddSignature()">
  <span class="field-placeholder d-block" *ngIf="!field.value">
    <i class="cs-icon cs-icon-sign ml-1"></i>
    <ng-container i18n>Click here to sign</ng-container><i class="text-danger" *ngIf="field.required">*</i>
  </span>
  <img [src]="field.value" alt="signature" *ngIf="field.value" [ngStyle]="signatureStyle" />
</div>
